import { formatDollars } from '@open-tender/utils'

/** Display settings slice used for price-per-person (CATERING). Extend when selector typing adds showPricePerPerson. */
export type DisplaySettingsWithPricePerPerson = { showPricePerPerson?: boolean }

export const ORDER_TYPE_CATERING = 'CATERING'

/**
 * Whether to show price per person in the UI. Only true when order type is CATERING
 * and display settings enable it (backend sends the correct config per order type).
 */
export function shouldShowPricePerPerson(
  orderType: string | null | undefined,
  displaySettings: DisplaySettingsWithPricePerPerson | null | undefined
): boolean {
  return (
    orderType === ORDER_TYPE_CATERING && !!displaySettings?.showPricePerPerson
  )
}

type Args = {
  baseDisplayPrice: string
  /** Price in dollars (string from API), e.g. "119.99" */
  priceDollars?: number | string | null
  serves?: number | string | null
  showPricePerPerson?: boolean
}

export function getDisplayPriceForPerPerson({
  baseDisplayPrice,
  priceDollars,
  serves,
  showPricePerPerson,
}: Args): string {
  const servesNum = Number(serves)
  const priceNum = Number(priceDollars)

  if (!showPricePerPerson) return baseDisplayPrice
  if (!Number.isFinite(servesNum) || servesNum <= 0) return baseDisplayPrice
  if (!Number.isFinite(priceNum) || priceNum <= 0) return baseDisplayPrice

  const perPersonDollars = Math.floor(priceNum / servesNum * 100) / 100
  return `${formatDollars(String(perPersonDollars))}/person`
}
